<template>
    <div>
        <div class="px-4 pt-10 pb-5">
            <div class="w-full text-center">
                <h2 v-text="$t('GOT_MORE_QUESTIONS')"></h2>
            </div>
            <div class="theIntroductions-moreHelp__container w-full mx-auto md:w-2/3">
                    <!-- Telephone -->
                <div class="centerItems">
                    <img src="@/assets/images/decoration/telephone-icon.png" alt="Call">
                    <a class="underline font-light hover:no-underline" :href="`tel:${contactNumber}`">
                            {{$t('COMPANY_TELEPHONE', {contactNumber})}}
                        </a>
                </div>

                <!-- Email -->
                <div class="centerItems">
                    <img src="@/assets/images/decoration/email-icon.png" alt="Email">
                    <a class="underline font-light hover:no-underline" :href="`mailto:${email}`">
                            {{ email }}
                        </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GotMoreQuestions',
    data() {
        return {
            email: process.env.VUE_APP_EMAIL,
            contactNumber: process.env.VUE_APP_TELEPHONE,
        };
    },
};
</script>

<style lang="scss" scoped>
.centerItems {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    margin: 10px;
    img {
        width: 30px;
        height: auto;
        margin-right: 20px;
    }
}
</style>
